import React from 'react';
import { connect } from 'react-redux';
import { modal } from 'react-redux-modal';
import { SocialLogin } from '../';
import {
  SignUpModalView,
} from '../';
import './styles.scss';

class SignUpView extends React.Component {

  constructor(props) {
    super(props);
    this.openSignup = this.openSignup.bind(this);
  }

  componentWillMount() {

  }

  componentDidMount() {

  }

  openSignup(e) {
    e.preventDefault();
    modal.add(SignUpModalView, { title: '', size: 'medium', hideTitleBar: true, id: 'signup' });
  }

  render() {
    return (
      <div>
        <h1> Welcome to the Explore community!</h1>

        <p className="u-font-foundation-roman u-textSize-24">
          Become part of the world&apos;s largest live nature network!
        </p>

        <div className="float-right ml-2 mb-2" style={{ maxWidth: '50%' }}>
          <img className="img-fluid" src="/images/bears_screenshot.jpg" />
        </div>
        <p>
          Explore is a multimedia organization that documents leaders around the world who have devoted their lives to extraordinary causes. Both educational and inspirational, explore creates a portal into the soul of humanity by championing the selfless acts of others.
        </p>
        <p>
          Sign up today to join Explore&apos;s vibrant community. Having an account grants you access to many amazing features.
        </p>

        <ul>
          <li>Participate in the discussion communities for each stream.</li>
          <li>Take snapshots and share your favorite pics with friends and family.</li>
          <li>Favorite live cams to easily return to your favorite animals.</li>
          <li>Enjoy nature as it was meant to be experienced, untouched by human influence.</li>
        </ul>

        <p>
          Sign up today! It&apos;s absolutely free!
        </p>

        <div className="text-center mb-5">
          <a
            className="d-inline-block text-center u-font-foundation-roman text-uppercase cta-button"
            onClick={(e) => { this.openSignup(e); }}
          >
            sign up
          </a>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(SignUpView);
